module.exports = __webpack_public_path__ + "static/media/logo.65291c0b.svg";